import { render, staticRenderFns } from "./EditChild.vue?vue&type=template&id=2eef6eef&"
import script from "./EditChild.vue?vue&type=script&lang=js&"
export * from "./EditChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports